module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/branches-list/branches-list.component.scss
// module id = ./src/app/components/branches-list/branches-list.component.scss
// module chunks = main